import axios from "@/api/axiosInstance";
import {
  AddCompanyPermissionOverrideRequest,
  AddCompanyPermissionOverrideResponse,
} from "./types";

export const addCompanyPermissionOverride = async (
  companyUuid: string,
  requestData: AddCompanyPermissionOverrideRequest,
): Promise<AddCompanyPermissionOverrideResponse> => {
  const response = await axios.post<AddCompanyPermissionOverrideResponse>(
    `/api/private/admin/companies/${companyUuid}/permission-overrides`,
    requestData,
  );
  return response.data;
};
